// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__3vP-g","bug":"styles_bug__2JvS0","message":"styles_message__3FYmx","close":"styles_close__bbNEZ"};